export class Page {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.name = "Page";
    this.scene = "Page";
    this.data = [];
  }

  async preview({ options }) {
    this.page = options.page;
    this.onAir = false;
    this.options = options;
    let xml = await this.getVizPage({ page: this.page });

    await this.updateVizPage({ page: this.page, data: xml });
    this.sendPreview("page:read " + this.page);
    this.comms(options);
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.sendAnimateOff({ page: this.page });
    this.onAir = false;
  }
}
